'use strict';

var _require = require('lodash'),
    chain = _require.chain,
    identity = _require.identity,
    trim = _require.trim,
    truncate = _require.truncate;

var removeHeadersMarkdown = function removeHeadersMarkdown(text) {
  return text.replace(/{\$h\d}(.*?){\$h}/g, function (_match, group) {
    return group;
  });
};

var getContentText = function getContentText(content, maxLength) {
  var text = chain(content).get('blocks', []).filter(function (block) {
    return block.type !== 'atomic';
  }).map(function (block) {
    return trim(block.text);
  }).map(removeHeadersMarkdown).filter(identity).join(' ').value();

  if (maxLength) {
    return truncate(text, { length: maxLength });
  } else {
    return text;
  }
};

module.exports = {
  getContentText: getContentText
};